export const getMarginInRems = weight => {
  return 0.25 * (weight === undefined ? 1 : weight)
}
